import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
export default defineComponent({
    name: 'Login',
    setup() {
        const email = ref('');
        const password = ref('');
        const rememberMe = ref(false);
        const errorMessage = ref('');
        const router = useRouter();
        const handleLogin = async () => {
            console.log('Attempting login with:', email.value, 'passwordLength:', String(password.value).length, 'remember:', rememberMe.value);
            if (!email.value || !password.value) {
                errorMessage.value = 'Please fill in both fields.';
                return;
            }
            errorMessage.value = '';
            try {
                // debug: show firebase app config used by auth
                try {
                    // @ts-ignore
                    console.log('firebase auth app options:', auth?.app?.options || null);
                }
                catch (e) {
                    console.warn('failed reading auth.app.options', e);
                }
                // Sign in the user
                const userCredential = await signInWithEmailAndPassword(auth, email.value, password.value);
                console.log('signInWithEmailAndPassword result:', userCredential);
                const user = userCredential.user;
                // debug: currentUser and token
                console.log('auth.currentUser after signIn:', auth.currentUser);
                const tokenResult = await user.getIdTokenResult(true).catch(e => { console.warn('getIdTokenResult error', e); return null; });
                console.log('idTokenResult:', tokenResult);
                // Redirect to dashboard
                router.push('/app/dashboard');
            }
            catch (error) {
                console.error('signIn error:', error);
                if (error.code === 'auth/user-not-found') {
                    errorMessage.value = 'No account found with this email.';
                }
                else if (error.code === 'auth/wrong-password') {
                    errorMessage.value = 'Incorrect password.';
                }
                else {
                    errorMessage.value = error.message || 'Login failed. Please try again.';
                }
            }
        };
        return {
            email,
            password,
            rememberMe,
            errorMessage,
            handleLogin,
        };
    },
});
